var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('a-config-provider',{attrs:{"locale":_vm.zh_CN}},[(_vm.isRouterAlice)?_c('router-view'):_vm._e()],1),(_vm.isLoading)?_c('div',{staticClass:"fixbg1"},[_c('a-spin')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }